import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    height: '15rem',
    justifyContent: 'space-evenly',
    flexDirection: 'column',
    alignItems: 'center',
    border: `1px dashed ${theme.palette.container.border}`,
  },
  root: {
    padding: '6rem',
  },
  text: {
    color: theme.palette.text.primary,
    fontStyle: 'italic',
  },
}));

export default useStyles;
